import React, { ReactElement } from 'react';
import dynamic from 'next/dynamic';
import classNames from 'classnames/bind';
import RootLayout from 'layouts/RootLayout';
import styles from 'pages/company/faqs/Faqs.module.scss';

const cn = classNames.bind(styles);

const SectionHeader = dynamic(() => import('sections/Company/Faqs/SectionHeader'));
const SectionContent = dynamic(() => import('sections/Company/Faqs/SectionContent'));

export default function Faqs() {
  return (
    <div className={cn('faqs')}>
      <SectionHeader />
      <SectionContent />
    </div>
  );
}

export const getStaticProps = async () => {
  return {
    props: {
      title: 'Visit Our FAQ for Assistance | DF Alliance',
      description:
        'Visit the DF Alliance FAQ for a comprehensive range of resources, FAQs, and support to guide you through the freight forwarding process.',
      path: '/company/faqs',
    },
  };
};

Faqs.getLayout = function getLayout(page: ReactElement) {
  return <RootLayout>{page}</RootLayout>;
};
